import React from 'react'
import { Header } from '../components/Header'
import { Footer } from '../components/Footer'
import { PricingSection } from '../components/PricingSection'
import { useTranslation } from 'react-i18next'

export const Pricing: React.FC = () => {
  const { t } = useTranslation()

  const redirectToApp = () => {
    const mainAppUrl = import.meta.env.VITE_MAIN_APP_URL || 'https://app.nazwolab.pl'
    window.location.href = mainAppUrl
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20 pb-16">
        <PricingSection />

        {/* Strong CTA Section */}
        <section className="py-16 px-4 bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600">
          <div className="max-w-4xl mx-auto text-center">
            <div className="mb-8">
              <span className="inline-block px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm font-medium mb-6">
                🎉 {t('pricing.cta.badge', 'Rozpocznij bez ryzyka')}
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                {t('pricing.cta.title', 'Gotowy na najlepsze nazwy domen?')}
              </h2>
              <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
                {t('pricing.cta.description', 'Dołącz do tysięcy przedsiębiorców, którzy znaleźli idealne domeny z pomocą AI. Zacznij za darmo już dziś - nie potrzebujesz karty kredytowej.')}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
              <button
                onClick={redirectToApp}
                className="px-8 py-4 bg-white text-blue-600 font-bold rounded-lg hover:bg-gray-50 transition-all duration-200 text-lg shadow-2xl hover:shadow-3xl transform hover:scale-105 min-w-64"
              >
                {t('pricing.cta.button', 'Wypróbuj za darmo →')}
              </button>
              <a
                href="/getting-started"
                className="px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-lg hover:bg-white/10 transition-all duration-200 text-lg"
              >
                {t('pricing.cta.learnMore', 'Jak to działa?')}
              </a>
            </div>

            <div className="flex flex-wrap justify-center items-center gap-6 text-white/90 text-sm">
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-green-300" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span>{t('pricing.cta.features.0', 'Bez karty kredytowej')}</span>
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-green-300" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span>{t('pricing.cta.features.1', '50 darmowych zapytań')}</span>
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-green-300" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span>{t('pricing.cta.features.2', 'Rezygnacja w każdej chwili')}</span>
              </div>
            </div>
          </div>
        </section>

        {/* Social Proof / Trust Section */}
        <section className="py-12 px-4 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8">
              <p className="text-gray-600 text-lg mb-6">
                {t('pricing.trust.title', 'Dołącz do przedsiębiorców, którzy nam zaufali')}
              </p>
              <div className="flex flex-wrap justify-center items-center gap-8 text-gray-500">
                <div className="text-center">
                  <div className="text-3xl font-bold text-gray-900">1000+</div>
                  <div className="text-sm">{t('pricing.trust.users', 'Użytkowników')}</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-gray-900">10k+</div>
                  <div className="text-sm">{t('pricing.trust.domains', 'Wygenerowanych domen')}</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-gray-900">4.8/5</div>
                  <div className="text-sm">{t('pricing.trust.rating', 'Średnia ocena')}</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}
